import * as React from 'react';
import * as Sentry from '@sentry/browser';
import { configureSentry } from './configureSentry';
import StandardErrorPage from './StandardErrorPage';
import { appVersion } from '../../appVersion';

export interface ErrorBoundaryProps {}

interface State {
  error?: any;
  versionMismatch: boolean;
  eventId?: any;
  local: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, State> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    let local = false;
    if (
      location.hostname === 'localhost' ||
      location.hostname === '127.0.0.1' ||
      location.hostname === ''
    ) {
      local = true;
    }
    this.state = { error: null, eventId: null, local, versionMismatch: false };
  }

  componentDidMount(): void {
    if (!this.state.local) {
      configureSentry();
    }
  }

  componentDidCatch(error: any, errorInfo: any) {
    this.setState({ error });
    if (this.state.local) {
      return;
    }
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      let eventId = '';
      if (error instanceof Error) {
        eventId = Sentry.captureException(error);
      } else {
        scope.setExtra('error', error);
        scope.setTag('frontend_version', appVersion);
        eventId = Sentry.captureException(
          new Error('Unknown error occurred, check the extra information')
        );
      }
      this.setState((prev) => ({ ...prev, eventId }));
    });
  }

  render() {
    if (this.state.error) {
      return <StandardErrorPage />;
    }

    return <>{this.props.children}</>;
  }
}
export default ErrorBoundary;
